import React, { useEffect, useState, useRef } from "react";
import { Nav, Tab } from "react-bootstrap";
import Slider from "react-slick";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { sportsSocket } from "../../../../utils/socketUtil.js";
import { setSportsData, setOddsData } from "../../../../redux/sports/actions";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Footer from "../../../../containers/Footer";
import LeftBarSports from "../../../components/LeftBarSports.js";
import RightBarCasino from "../../../components/RightBarCasino.js";
import SportsItem from "./children";
import InPlay from "./children/inplay";

import ExchangeIcon from "../../../../assets/images/icons/sports/Exchange-new.png";
import SportsIcon from "../../../../assets/images/icons/sports/Sports.png";
import CasinoIcon from "../../../../assets/images/icons/sports/Casino.png";
import AviatorICon from "../../../../assets/images/icons/sports/Aviator.png";
import SlotsIcon from "../../../../assets/images/icons/sports/Slots.png";
import LiveCasinoIcon from "../../../../assets/images/icons/sports/LiveCasino.png";

import promotionIcon1 from "../../../../assets/images/banner/home/blastoff-icon.svg";
import promotionIcon2 from "../../../../assets/images/banner/home/evoicon.svg";
import promotionIcon3 from "../../../../assets/images/banner/home/sportsicon.svg";
import promotionIcon4 from "../../../../assets/images/banner/home/casinoicon.svg";
import promotionIcon5 from "../../../../assets/images/banner/home/ecricketicon.svg";
import promotionIcon6 from "../../../../assets/images/banner/home/cardicon.svg";
import promotionIcon7 from "../../../../assets/images/banner/home/sloticon.svg";
import promotionIcon8 from "../../../../assets/images/banner/home/multiicon.png";
import promotionIcon9 from "../../../../assets/images/banner/home/fishingicon.png";

import indiancardicon from "../../../../assets/images/icons/home/playing-cards.png";
import promotiongames from "../../../../assets/images/icons/home/crown.png"

import VivoTeenPatti from "../../../../assets/images/casino/indian-card/TeenPattiVivo.png";
import VivoAndarBahar from "../../../../assets/images/casino/indian-card/AndarBaharVivo.png";
import game1 from "../../../../assets/images/casino/indian-card/TeenPatti.png";
import game2 from "../../../../assets/images/casino/indian-card/Teenpatti2020.png";
import game3 from "../../../../assets/images/casino/indian-card/AndarBahar.png";
import game4 from "../../../../assets/images/casino/indian-card/32Cards.png";
import game5 from "../../../../assets/images/casino/indian-card/Roulette.png";
import game6 from "../../../../assets/images/casino/indian-card/AkbarRomeoWalter.png";
import game7 from "../../../../assets/images/casino/indian-card/CricketWar.png";
import game8 from "../../../../assets/images/casino/indian-card/Sicbo.png";
import game9 from "../../../../assets/images/casino/indian-card/Baccarat.png";
import game11 from "../../../../assets/images/casino/indian-card/DragonTIger.png";
import game12 from "../../../../assets/images/casino/indian-card/OneDayTeenPatti.png";
import game14 from "../../../../assets/images/casino/indian-card/CasinoQueen.png";
import game15 from "../../../../assets/images/casino/indian-card/AndarBaharClassic.png";
import game16 from "../../../../assets/images/casino/indian-card/GoasAndarbahar.png";
import game17 from "../../../../assets/images/casino/indian-card/Lucky7.png";
import game21 from "../../../../assets/images/casino/indian-card/RNG3PlayerTeenpatti.png";
import game22 from "../../../../assets/images/casino/indian-card/RNG32Cards.png";
import game23 from "../../../../assets/images/casino/indian-card/RNGAkbarromeowalter.png";
import game25 from "../../../../assets/images/casino/indian-card/RNGBaccarat.png";
import game27 from "../../../../assets/images/casino/indian-card/RNGCasinoQueen.png";
import game28 from "../../../../assets/images/casino/indian-card/RNGCasinoQueen2020.png";
import game30 from "../../../../assets/images/casino/indian-card/RNGDragonTiger.png";
import game31 from "../../../../assets/images/casino/indian-card/RngDragonTiger2020.png";
import game32 from "../../../../assets/images/casino/indian-card/RNGJocker.jpg";
import game36 from "../../../../assets/images/casino/indian-card/RNGTeenPatti3.jpg";
import game37 from "../../../../assets/images/casino/indian-card/RNGteenPatti2020.png";
import game38 from "../../../../assets/images/casino/indian-card/TeenpattiFaceOff.png";
import game40 from "../../../../assets/images/casino/indian-card/CricketAutoRoulette.png";

import game10 from "../../../../assets/images/casino/WorliMatka.jpg";
import game18 from "../../../../assets/images/casino/Poker.jpg";
import game20 from "../../../../assets/images/casino/RNG3CardsJudgement.jpg";
import game29 from "../../../../assets/images/casino/RNgCricket2020.jpg";
import game33 from "../../../../assets/images/casino/RNGKabutarFuddi.jpg";
import game34 from "../../../../assets/images/casino/RNGPoker.jpg";
import game35 from "../../../../assets/images/casino/RNGPoker2020.jpg";

import populargame1 from "../../../../assets/images/casino/popular/vivo-andar-bahar.jpg";
import populargame2 from "../../../../assets/images/casino/popular/vivo-teen-patti.jpg";
import populargame3 from "../../../../assets/images/casino/popular/vivo-oracle-blaze-roulette.jpg";
import populargame4 from "../../../../assets/images/casino/popular/vivo-portomaso-roulette.jpg";
import populargame5 from "../../../../assets/images/casino/popular/vivo-las-vegas-roulette.jpg";
import populargame6 from "../../../../assets/images/casino/popular/vivo-macau-baccarat.jpg";
import populargame7 from "../../../../assets/images/casino/popular/vivo-limitless-blackjack.jpg";
import populargame8 from "../../../../assets/images/casino/popular/vivo-las-vegas-blackjack.jpg";
import populargame9 from "../../../../assets/images/casino/popular/vivo-dragon-tiger.jpg";

import populargame10 from "../../../../assets/images/casino/popular/GonzosTreasureHunt.jpg";
import populargame11 from "../../../../assets/images/casino/popular/Auto-Roulette.jpg";
import populargame12 from "../../../../assets/images/casino/popular/BetOnTeenPatti.jpg";
import populargame13 from "../../../../assets/images/casino/popular/AndarBahar.jpg";
import populargame14 from "../../../../assets/images/casino/popular/Baccarat.jpg";
import populargame15 from "../../../../assets/images/casino/popular/lucky7.jpg";
import populargame16 from "../../../../assets/images/casino/popular/CrazyTime.jpg";
import populargame17 from "../../../../assets/images/casino/popular/GoldBlackjack4.jpg";
import populargame18 from "../../../../assets/images/casino/popular/Baccarat12.jpg";
import populargame19 from "../../../../assets/images/casino/popular/NamasteRoulette1.jpg";
import populargame20 from "../../../../assets/images/casino/popular/UltimateRoulette1.jpg";
import populargame21 from "../../../../assets/images/casino/popular/DragonTiger.jpg";

import casino1 from "../../../../assets/images/casino/provider/Ezugi.jpg";
import casino2 from "../../../../assets/images/casino/provider/Evolution.jpg";
import casino3 from "../../../../assets/images/casino/provider/Vivogaming.jpg";
import casino4 from "../../../../assets/images/casino/provider/Supernova.jpg";
import casino5 from "../../../../assets/images/casino/provider/WorldCasino.jpg";
import casino6 from "../../../../assets/images/casino/provider/XPG.jpg";
import casino7 from "../../../../assets/images/casino/provider/virtualsports.jpg";
import casino8 from "../../../../assets/images/casino/provider/OneTouch.jpg";
import casino9 from "../../../../assets/images/casino/provider/Paragmatic.jpg";
import casino10 from "../../../../assets/images/casino/provider/Qtech.jpg";
import casino11 from "../../../../assets/images/casino/provider/Aesexy.jpg";

import WhatsappIcon from "../../../../assets/images/icons/home/whatsapp.png";

import { showbetSlip } from "../../../../redux/sports/actions";
import BetSlip from "../../../components/betSlip";
import { betSlipContent } from "../../../../redux/sports/actions";
import BackIcon from "../../../../assets/svg/BackIcon";
import MainSlider from "../../../../containers/MainSlider.js";
import { getBanners } from "../../../../redux/app/actions.js";

import ExchangeLobbyPage from "../exchange/ExchangeLobbyPage.js";

import kingmakerImg from "../../../../assets/images/banner/KingMaker.jpg";
import JiliImg from "../../../../assets/images/casino/provider/JiliGames.jpg";
import WhatsAppCard from "../../../components/WhatsAppCard.js";

import JetxImg from "../../../../assets/images/casino/promotional-image/Jetx.jpg"
import AviatorImg from "../../../../assets/images/casino/promotional-image/Aviator.jpg"
import CrazyTimeImg from "../../../../assets/images/casino/promotional-image/CrazyTime.jpg"
import MinesImg from "../../../../assets/images/casino/promotional-image/mines.webp"



const Sports = ({ isAuth }) => {
  const { banners } = useSelector((state) => state.app);
  const { appDetails } = useSelector((state) => state.app);
  useEffect(() => {
    dispatch(getBanners());
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("2");
  const { sportsData, oddsData, showBetSlip } = useSelector(
    (state) => state.sports
  );

  // useEffect(() => {
  //   sportsSocket.on("markets", (data) => {
  //     // console.log("data", data);
  //     dispatch(setSportsData(data.markets));
  //   });
  //   sportsSocket.on("marketodds", (data) => {
  //     // console.log("data", data);
  //     // console.log("data", data);
  //     dispatch(setOddsData(data.marketOdds));
  //   });
  //   return () => {
  //     sportsSocket.off();
  //   };
  // }, []);

  useEffect(() => {
    if (location?.state?.selectedTab) {
      console.log("location?.state?.selectedTab", location?.state?.selectedTab);
      setActiveKey(location.state.selectedTab);
    }
  }, [location]);

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`
    );
  };

  const handleBetSlip = (value) => {
    //dispatch(showbetSlip(value));
  };

  const handleBetSlipContent = (data) => {
    // dispatch(betSlipContent(data));
  };

  const middleContentRef = useRef(null);
  const scrollToElement = (elementId) => {
    const targetElement = document.getElementById(elementId);
    if (targetElement && middleContentRef.current) {
      const offsetTop = targetElement.offsetTop;
      const middleContentTop = middleContentRef.current.offsetTop;
      const offset = offsetTop - middleContentTop;

      if (window.innerWidth < 1200) {
        window.scrollTo({
          top: offset - 5,
          behavior: "smooth",
        });
      } else {
        middleContentRef.current.scrollTo({
          top: offset - 5,
          behavior: "smooth",
        });
      }
    }
  };

  const settings = {
    arrows: false,
    dots: false,
    swipeToSlide: true,
    infinite: true,
    autoplay: true,

    slidesToShow: 2,
    slidesToScroll: 1,

    speed: 3000,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  const tabs = [
    {
      id: 1,
      eventKey: "1",
      name: "In play",
    },
    {
      id: 2,
      eventKey: "2",
      name: "Cricket",
    },
    {
      id: 3,
      eventKey: "3",
      name: "Soccer",
    },
    {
      id: 4,
      eventKey: "4",
      name: "Tennis",
    },
  ];

  return (
    <>
      <div className="home-page">
        {isAuth ? <HeaderAfterLogin /> : <Header />}

        <main className="main d-flex">
          <LeftBarSports />

          <div ref={middleContentRef} className="middleContentSec">
            <div className="rightSec">
              <div className="middleSec">
                <div className="sports_page_banner">
                  <MainSlider banners={banners} />
                </div>

                <div className="sport-buttons">
                  <ul>
                    <li>
                      <a href="/spmsports/cricket">
                        <img src={ExchangeIcon} alt="cricket-icon" />
                        <span>Exchange</span>
                      </a>
                    </li>
                    <li>
                      <a href="/atlas-lobby">
                        <img src={SportsIcon} alt="cricket-icon" />
                        <span>Sports</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="#populargames"
                        onClick={() => scrollToElement("indiancardgames")}
                      >
                        <img src={CasinoIcon} alt="Football-icon" />
                        <span>Casino</span>
                      </a>
                    </li>
                    <li>
                      <a href="/casino/spribe/aviator">
                        <img src={AviatorICon} alt="Tennis-icon" />
                        <span>Aviator</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="/Slots"
                        onClick={() => scrollToElement("populargames")}
                      >
                        <img src={SlotsIcon} alt="HorseRace-icon" />
                        <span>Slots</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="#casinogames"
                        onClick={() => scrollToElement("casinogames")}
                      >
                        <img src={LiveCasinoIcon} alt="Greyhound-icon" />
                        <span>Live Casino</span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="promotion-buttons d-none">
                  <ul>
                    <li>
                      <a href="" className="promotion-banner promotionBanner1">
                        <img src={promotionIcon1} alt="aviatoricon" />
                        Aviator
                      </a>
                    </li>
                    <li>
                      <a href="" className="promotion-banner promotionBanner2">
                        <img src={promotionIcon2} alt="Evolution" />
                        Evolution
                      </a>
                    </li>
                    <li>
                      <a
                        href="/atlas-lobby"
                        className="promotion-banner promotionBanner3"
                      >
                        <img src={promotionIcon3} alt="Sportsbook" />
                        Sportsbook
                      </a>
                    </li>
                    <li>
                      <a href="" className="promotion-banner promotionBanner4">
                        <img src={promotionIcon4} alt="Live Casino" />
                        Live Casino
                      </a>
                    </li>
                    <li>
                      <a
                        href="/spmsports/cricket"
                        className="promotion-banner promotionBanner5"
                      >
                        <img src={promotionIcon5} alt="E-Cricket" />
                        E-Cricket
                      </a>
                    </li>
                    <li>
                      <a href="" className="promotion-banner promotionBanner6">
                        <img src={promotionIcon6} alt="CardGames" />
                        CardGames
                      </a>
                    </li>
                    <li>
                      <a href="" className="promotion-banner promotionBanner7">
                        <img src={promotionIcon7} alt="Slots Games" />
                        Slots Games
                      </a>
                    </li>
                    <li>
                      <a href="" className="promotion-banner promotionBanner8">
                        <img src={promotionIcon8} alt="Multiplayer Games" />
                        Multiplayer Games
                      </a>
                    </li>
                    <li>
                      <a href="" className="promotion-banner promotionBanner9">
                        <img src={promotionIcon9} alt="Fishing Games" />
                        Fishing Games
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="container-fluid d-none">
                  <div className="home-iframe ">
                    {isAuth ? (
                      <div>
                        <ExchangeLobbyPage />
                      </div>
                    ) : (
                      <div className="beforelogin-iframe">
                        <iframe src="https://design.powerplay247.com/auth" />
                      </div>
                    )}
                  </div>
                </div>

                <div className="container d-none">
                  <div className="sports_page custom-tabs">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="2"
                      activeKey={activeKey}
                    >
                      <Nav variant="pills" className="top_nav">
                        {tabs.map((item, index) => {
                          return (
                            <Nav.Item
                              key={index}
                              onClick={() => setActiveKey(item.eventKey)}
                            >
                              <Nav.Link eventKey={item.eventKey}>
                                {item.name}
                              </Nav.Link>
                            </Nav.Item>
                          );
                        })}
                        <a href="/mybets" className="openbets">
                          Open Bets
                        </a>
                      </Nav>
                      <Tab.Content>
                        <Tab.Pane eventKey="1">
                          <InPlay
                            sportsData={sportsData}
                            oddsData={oddsData}
                            handleEventClick={handleEventClick}
                            handleBetSlip={handleBetSlip}
                            handleBetSlipContent={handleBetSlipContent}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="2">
                          <SportsItem
                            sportsData={
                              sportsData &&
                              sportsData.find(
                                ({ sportname }) => sportname === "Cricket"
                              )
                            }
                            oddsData={oddsData}
                            handleEventClick={handleEventClick}
                            handleBetSlip={handleBetSlip}
                            handleBetSlipContent={handleBetSlipContent}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="3">
                          <SportsItem
                            sportsData={
                              sportsData &&
                              sportsData.find(
                                ({ sportname }) => sportname === "Soccer"
                              )
                            }
                            oddsData={oddsData}
                            handleEventClick={handleEventClick}
                            handleBetSlip={handleBetSlip}
                            handleBetSlipContent={handleBetSlipContent}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="4">
                          <SportsItem
                            sportsData={
                              sportsData &&
                              sportsData.find(
                                ({ sportname }) => sportname === "Tennis"
                              )
                            }
                            oddsData={oddsData}
                            handleEventClick={handleEventClick}
                            handleBetSlip={handleBetSlip}
                            handleBetSlipContent={handleBetSlipContent}
                          />
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                    {/* <Tabs defaultActiveKey={activeKey}>
                      <Tab
                        eventKey="1"
                        title="In Play"
                        onClick={() => setActiveKey("1")}
                      >
                        <SportsItem
                          sportsData={
                            sportsData &&
                            sportsData.find(({ sportname }) => sportname === "Soccer")
                          }
                          oddsData={oddsData}
                          handleEventClick={handleEventClick}
                        />
                      </Tab>
                      <Tab
                        eventKey="2"
                        title="Cricket"
                        onClick={() => setActiveKey("2")}
                      >
                        <div className="banner mb-3">
                          <img src="./images/GS-01.png" />
                        </div>
                        <SportsItem
                          sportsData={
                            sportsData &&
                            sportsData.find(({ sportname }) => sportname === "Cricket")
                          }
                          oddsData={oddsData}
                          handleEventClick={handleEventClick}
                        />
                      </Tab>
                      <Tab
                        eventKey="3"
                        title="Soccer"
                        onClick={() => setActiveKey("3")}
                      >
                        <SportsItem
                          sportsData={
                            sportsData &&
                            sportsData.find(({ sportname }) => sportname === "Tennis")
                          }
                          oddsData={oddsData}
                          handleEventClick={handleEventClick}
                        />
                      </Tab>
                      <Tab
                        eventKey="4"
                        title="Tennis"
                        onClick={() => setActiveKey("4")}
                      >
                        <SportsItem
                          sportsData={
                            sportsData &&
                            sportsData.find(({ sportname }) => sportname === "Soccer")
                          }
                          oddsData={oddsData}
                          handleEventClick={handleEventClick}
                        />
                      </Tab>
                    </Tabs> */}
                  </div>
                </div>


                <div className="container" id="indiancardgames">
                  <div className="indian-card-games">
                    <div className="game-heading">
                      <h3>
                        <img src={promotiongames} alt="indian-card-game-icon" />
                        Promotional Games
                      </h3>
                      <a href="/promotion" className="openbets promotionBox">
                        Promotion
                      </a>
                   
                    </div>
                    <ul className="exchangeGames-content PromotionGames">
                    
                      <li className="exchangeGames-item">
                        <a href="/casino/spribe-aviator">
                          <img
                            src={AviatorImg}
                            alt="gameimage1"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezgevo-crazy-time">
                          <img
                            src={CrazyTimeImg}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/spribe-mines">
                          <img
                            src={MinesImg}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/aggapsmartsoftgaming-jetx">
                          <img
                            src={JetxImg}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                     
                    </ul>
                  </div>
                </div>

                <div className="container" id="indiancardgames">
                  <div className="indian-card-games">
                    <div className="game-heading">
                      <h3>
                        <img src={indiancardicon} alt="indian-card-game-icon" />
                        Indian Card Games
                      </h3>
                      <a href="/casino/ezugi" className="openbets">
                        SHOW ALL
                      </a>
                    </div>
                    <ul className="exchangeGames-content">
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/vivo-teen-patti">
                          <img
                            src={VivoTeenPatti}
                            alt="vivo teen patti"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/vivo-andar-bahar">
                          <img
                            src={VivoAndarBahar}
                            alt="vivo andar bahar"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-teen-patti-3-card">
                          <img
                            src={game1}
                            alt="gameimage1"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-bet-on-teen-patti">
                          <img
                            src={game2}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-andar-bahar">
                          <img
                            src={game3}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-32-cards">
                          <img
                            src={game4}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-spanish-roulette">
                          <img
                            src={game5}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-akbar-romeo-walter">
                          <img
                            src={game6}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-cricket-war">
                          <img
                            src={game7}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-sic-bo">
                          <img
                            src={game8}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-baccarat">
                          <img
                            src={game9}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/sn-worli-matka">
                          <img
                            src={game10}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-dragon-tiger">
                          <img
                            src={game11}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-one-day-teen-patti">
                          <img
                            src={game12}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-casino-queen">
                          <img
                            src={game14}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-classic-andar-bahar">
                          <img
                            src={game15}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-goas-andar-bahar">
                          <img
                            src={game16}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-lucky-7">
                          <img
                            src={game17}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/sn-poker">
                          <img
                            src={game18}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-3-cards-judgement">
                          <img
                            src={game20}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-3-player-teen-patti">
                          <img
                            src={game21}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-32-cards">
                          <img
                            src={game22}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-akbar-romeo-walter">
                          <img
                            src={game23}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-baccarat">
                          <img
                            src={game25}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-casino-queen">
                          <img
                            src={game27}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-casino-queen-2020">
                          <img
                            src={game28}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-cricket-2020">
                          <img
                            src={game29}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-dragon-tiger">
                          <img
                            src={game30}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-dragon-tiger-2020">
                          <img
                            src={game31}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-joker">
                          <img
                            src={game32}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-kabutar-fuddi">
                          <img
                            src={game33}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-poker">
                          <img
                            src={game34}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-poker-2020">
                          <img
                            src={game35}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-teen-patti">
                          <img
                            src={game36}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-rng-teen-patti-2020">
                          <img
                            src={game37}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/sn-teen-patti-face-off">
                          <img
                            src={game38}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-cricket-auto-roulette">
                          <img
                            src={game40}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="container" id="populargames">
                  <div className="indian-card-games populaGamesSection">
                    <div className="game-heading">
                      <h3>
                        <img src={indiancardicon} alt="indian-card-game-icon" />
                        Popular Games
                      </h3>
                      <a href="/casino/evolution" className="openbets">
                        SHOW ALL
                      </a>
                    </div>
                    <ul className="exchangeGames-content">
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/vivo-andar-bahar">
                          <img
                            src={populargame1}
                            alt="gameimage1"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/vivo-teen-patti">
                          <img
                            src={populargame2}
                            alt="gameimage1"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/vivo-oracle-blaze-roulette">
                          <img
                            src={populargame3}
                            alt="gameimage1"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/vivo-portomaso-roulette">
                          <img
                            src={populargame4}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/vivo-las-vegas-roulette">
                          <img
                            src={populargame5}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/vivo-macau-baccarat">
                          <img
                            src={populargame6}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/vivo-limitless-blackjack">
                          <img
                            src={populargame7}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/vivo-las-vegas-blackjack">
                          <img
                            src={populargame8}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/vivo-dragon-tiger">
                          <img
                            src={populargame9}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}

                      <li className="exchangeGames-item">
                        <a href="/casino/ezgrt-gonzos-quest-megaways">
                          <img
                            src={populargame10}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-auto-roulette">
                          <img
                            src={populargame11}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-bet-on-teen-patti">
                          <img
                            src={populargame12}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-andar-bahar">
                          <img
                            src={populargame13}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-baccarat">
                          <img
                            src={populargame14}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-lucky-7">
                          <img
                            src={populargame15}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezgevo-crazy-time">
                          <img
                            src={populargame16}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-gold-blackjack-4">
                          <img
                            src={populargame17}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-baccarat">
                          <img
                            src={populargame18}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-namaste-roulette">
                          <img
                            src={populargame19}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-ultimate-roulette">
                          <img
                            src={populargame20}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/ezg-dragon-tiger">
                          <img
                            src={populargame21}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="container" id="casinogames">
                  <div className="indian-card-games populaGamesSection">
                    <div className="game-heading">
                      <h3>
                        <img src={indiancardicon} alt="indian-card-game-icon" />
                        Casino
                      </h3>
                      <a href="/live-dealer" className="openbets">
                        SHOW ALL
                      </a>
                    </div>
                    <ul className="exchangeGames-content">
                      <li className="exchangeGames-item">
                        <a href="/casino/ezugi">
                          <img
                            src={casino1}
                            alt="gameimage1"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/evolution">
                          <img
                            src={casino2}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/vivo">
                          <img
                            src={casino3}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      <li className="exchangeGames-item">
                        <a href="/casino/supernowa">
                          <img
                            src={casino4}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/casino/aesexy">
                          <img
                            src={casino11}
                            alt="gameimage11"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/worldcasino">
                          <img
                            src={casino5}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/xpg">
                          <img
                            src={casino6}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      <li className="exchangeGames-item">
                        <a href="/atlas-lobby">
                          <img
                            src={casino7}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/onetouch">
                          <img
                            src={casino8}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      {/* <li className="exchangeGames-item">
                        <a href="/casino/pragamticplay">
                          <img
                            src={casino9}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li> */}
                      <li className="exchangeGames-item">
                        <a href="/casino/qtech">
                          <img
                            src={casino10}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/kingmaker">
                          <img
                            src={kingmakerImg}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                      <li className="exchangeGames-item">
                        <a href="/jili-games">
                          <img
                            src={JiliImg}
                            alt="gameimage2"
                            className="exchangeGames-img-body"
                          />
                          <div className="overlay">
                            <span>Play</span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <RightBarCasino />
            </div>

            {!isAuth ? <BeforeLoginFooter /> : <Footer />}
          </div>

          <div className="WhatappFixed">
            <WhatsAppCard url={appDetails?.WHATS_APP_URL}>
              <img src={WhatsappIcon} alt="whatsapp" />
            </WhatsAppCard>
          </div>
        </main>
      </div>
    </>
  );
};

export default Sports;
